import { useState, useEffect } from 'react';
import { List, PagedList } from 'src/types/common';
import { client } from 'src/utils/axios-client';
import BasicList from 'src/features/common/BasicList';
import GroupItem from 'src/features/common/GroupItem';

// 3rd party components
import "react-perfect-scrollbar/dist/css/styles.css";
import _ from 'lodash';

type ComponentProps<T> = {
    item: T
}

type Props<T> = {
    listName: string
    queryGroupsEndpoint: string,
    groupFilters: any,
    queryListEndpoint: string,
    getListFilters: (list: List) => any,
    Component: React.FC<ComponentProps<T>>
}

const GroupList = <T extends unknown>({ queryGroupsEndpoint, queryListEndpoint, groupFilters, getListFilters, listName, Component }: Props<T>) => {
    const [groups, setGroups] = useState({
        hasNextPage: false,
        pageNumber: 1,
        totalCount: 0,
        totalPages: 0,
        pageSize: 10000,
        items: [],
    } as PagedList<List>);

    useEffect(() => {
        loadGroups(1, groups.pageSize);
    }, [groupFilters]);

    const loadGroups = async (pageNumber: number, pageSize: number) => {
        const response = await client.post(queryGroupsEndpoint, { pageNumber, pageSize, ...groupFilters });

        const newItems = [...groups.items, ...response.data.items];

        setGroups({
            ...response.data,
            items: pageNumber === 1 ? response.data.items : newItems
        });
    }

    const onNextPage = () => {
        loadGroups(groups.pageNumber + 1, groups.pageSize);
    }

    if (groups.items.length === 0) return null;

    return <>{groups.items.map((group, index) => (
        <GroupItem key={`accord-${group.name}`} index={index} title={`${group.name} - ${group.totalCount} leads`}>
            {/*<BasicList queryRecordsEndpoint={queryListEndpoint} filters={getListFilters(group)} listName={group.name} Component={Component} list={group} updateList={()=> } />*/}
        </GroupItem>
    ))}</>
}

export { GroupList }

export default GroupList;